import { render, staticRenderFns } from "./exchangeRateTab.vue?vue&type=template&id=f4a01838&lang=pug"
import script from "./exchangeRateTab.vue?vue&type=script&lang=js"
export * from "./exchangeRateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports